// Each section replacement gets its own carousel and cleans up the previous one.
if (!customElements.get("maison-cart-addons")) {
  customElements.define(
    "maison-cart-addons",
    class extends HTMLElement {
      connectedCallback() {
        // Wait for children when the element is encountered by the HTML parser.
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.carousel = this.querySelector("[data-addon-carousel]");
          if (!this.carousel) return;
          this.items = Array.from(this.carousel.children);
          this.previous = this.querySelector("[data-addon-prev]");
          this.next = this.querySelector("[data-addon-next]");
          this.pagination = this.querySelector("[data-addon-pagination]");
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.pagination.replaceChildren(
            ...this.items.map((_, index) => {
              const button = document.createElement("button");
              button.type = "button";
              button.className = "maison_commerce-pagination-bullet";
              button.setAttribute(
                "aria-label",
                `${index + 1} / ${this.items.length}`,
              );
              button.addEventListener("click", () => this.goTo(index), options);
              return button;
            }),
          );
          this.previous.addEventListener(
            "click",
            () => this.goTo(this.currentIndex - 1),
            options,
          );
          this.next.addEventListener(
            "click",
            () => this.goTo(this.currentIndex + 1),
            options,
          );
          this.carousel.addEventListener(
            "scroll",
            () => this.update(),
            options,
          );
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.carousel);
          this.update();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }

      positions() {
        const origin = this.items[0]?.getBoundingClientRect().left || 0;
        return this.items.map(
          (item) => item.getBoundingClientRect().left - origin,
        );
      }

      goTo(index) {
        const positions = this.positions();
        this.currentIndex = Math.max(0, Math.min(index, positions.length - 1));
        this.carousel.scrollTo({
          left: positions[this.currentIndex] || 0,
          behavior: "smooth",
        });
        this.updateControls();
      }

      update() {
        const positions = this.positions();
        this.currentIndex = positions.reduce(
          (nearest, position, index) =>
            Math.abs(position - this.carousel.scrollLeft) <
            Math.abs(positions[nearest] - this.carousel.scrollLeft)
              ? index
              : nearest,
          0,
        );
        this.updateControls();
      }

      updateControls() {
        this.previous.disabled = this.currentIndex <= 0;
        this.next.disabled = this.currentIndex >= this.items.length - 1;
        [this.previous, this.next].forEach((button) =>
          button.classList.toggle("inactive", button.disabled),
        );
        Array.from(this.pagination.children).forEach((button, index) => {
          const active = index === this.currentIndex;
          button.classList.toggle("active", active);
          button.setAttribute("aria-current", active ? "true" : "false");
        });
      }
    },
  );
}
